module.exports = "/bundle/fontawesome-webfont.svg";